/* main entry point for all javascript imports */
import MobileMenu from './components/mobilemenu/mobilemenu';
import Megadrop from './components/megadrop/megadrop';
import FlickityComponent from './components/flickity/flickity';
import Share from './components/share/share';
import CookieConsent from './components/cookieconsent/cookieconsent';
import GlobalAlert from './components/globalalerts/globalAlert';
import MapOmraden from './components/map/mapOmraden';
import Popup from './components/popup/popup';

//import './components/bootstrap/util/polyfill.js';
//import './components/bootstrap/util/init.js';

//import Collapse from 'bootstrap.native/dist/bootstrap-native.js';

/**
 * App
 * This starting point for this application.
 * @version 1.0.0
 * @exports App
 */
export default class App {
	
    constructor() {

        // Init cookie consent
        CookieConsent();

        // Init global alerts
		new GlobalAlert();

		// Init popup
		new Popup();

		// Init mobile menu
		new MobileMenu();

		// Init megadrop
		new Megadrop();

		// Init map for Områden
		if (document.querySelectorAll('[data-type="multiselect"]').length > 0) {
			new MapOmraden();
		}

		// Init flickity carousel
		if (document.querySelectorAll('[data-type="carousel"]').length > 0) {
            new FlickityComponent();
		}

		// Share
		if (document.querySelectorAll('[data-type="share"]').length > 0) {
			new Share();
		}

		this.loadMisc();
	}

	loadMisc() {
		// When global search in header is shown, focus input
		$('#page-header-search').on('shown.bs.collapse', function () {
			$('.form-control-searchheader').focus();
		});
		$('#page-header-search').on('hidden.bs.collapse', function () {
			$('.form-control-searchheader').blur();
		});
	}
}
